import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const HiringTrendEnum = {
  '': {
    percentile: '',
    textPlacement: '',
    css: '',
    message: ''
  },
  'VERY LOW': {
    percentile: '23%',
    textPlacement: '25%',
    css: 'value--low',
    message: 'Very Low'
  },
  LOW: {
    percentile: '23%',
    textPlacement: '25%',
    css: 'value--low',
    message: 'Low'
  },
  MEDIUM: {
    percentile: '45%',
    css: 'value--medium',
    message: 'Medium'
  },
  HIGH: {
    percentile: '70%',
    css: 'value--high',
    message: 'High'
  },
  'VERY HIGH': {
    percentile: '90%',
    css: 'value--high',
    message: 'Very High'
  }
};

angular.module('major-explorer-data').constant('HiringTrendEnum', Enumeration('HiringTrendEnum', HiringTrendEnum));



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/types/hiring_trend_enum.ts